import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router, RouterModule } from '@angular/router';
import { FullCalendarModule } from '@fullcalendar/angular';
import { IWizRoute, WizModule, WizNavigationManager } from '@wizeoo/akm-component-lib';
import { AgGridModule } from 'ag-grid-angular';
import { GridsterModule } from 'angular-gridster2';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { AppComponent } from './app.component';
import { APIHttpInterceptor } from './manager/http/APIHttpInterceptor';
import { initializeKeycloak } from './manager/http/keycloak-initializer';
import { AppInitializer } from './manager/app-init';
import { FallbackView } from './views/fallback/fallback.view';

import { InformationBar } from './views/main/information/information.bar';
import { NavigationBar } from './views/main/menu/menu.bar';
import { TabBar } from './views/main/tabs/tab.bar';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CommonModule, InjectionService, NavigationEngine, PivotCellEditor, PivotHeaderGroupRenderer, TooltipService } from '@wizeoo/akm-common-lib';
import { AttachmentService } from '@wizeoo/akm-common-lib';
import { SwUpdateService } from './manager/worker/sw-update.service';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { RouteEngine } from './manager/routing/route.engine';
import { Model } from './model/model';
import { RootView } from './views/root/root.view';
import { UserTabView } from './views/user-tab/user-tab.view';
import { InitView } from './views/main/init.view';
import { NewtabView } from './views/newtab/newtab.view';
import { DashboardDataView } from './views/dashboard/datas/dashboard-data.view';
import { MatIconModule } from '@angular/material/icon';
import { UserPop } from './views/main/user/user.pop';
import { MenuPanel } from './views/main/left/menu.panel';
import { TestView } from './views/test/test.view';
import { QuestionsView } from './views/questions/questions.view';
import { AddView } from './views/add/add.view';
import { ListView } from './views/list/list.view';
import { MenuPopUp } from './views/main/menu/menu.pop';
import { LogView } from './views/log/log.view';
import { GatlingView } from './views/gatling/gatling.view';
import { ThumbView } from './views/thumb/thumb.view';
@NgModule({
  declarations: [
    AppComponent,
    InformationBar,
    NavigationBar,
    TabBar,
    FallbackView,
    RootView,
    UserTabView,
    InitView,
    AddView, ListView,
    NewtabView,
    DashboardDataView,
    UserPop, MenuPanel, MenuPopUp,
    TestView, 
    QuestionsView, LogView, GatlingView, ThumbView
  ],
  imports: [
    MatDialogModule,
    MatIconModule,
    WizModule,
    CommonModule,
    GridsterModule,
    FullCalendarModule,
    RouterModule.forRoot(RouteEngine.getRouteDefinition(), { useHash: false }),
    KeycloakAngularModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AgGridModule.withComponents([PivotCellEditor, PivotHeaderGroupRenderer]),


    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: true,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      // registrationStrategy: 'registerWhenStable:30000',
      registrationStrategy: 'registerImmediately'
    })
  ],
  providers: [
    MatDialogModule,
    WizModule,
    CommonModule,
    AppInitializer, // lancement des services d'init
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService, AppInitializer],
    },
    { provide: HTTP_INTERCEPTORS, useClass: APIHttpInterceptor, multi: true }, // Intercepteur pour construction de l'URL http correcte
    InjectionService,
    TooltipService,
    AttachmentService,
    SwUpdateService // lancement du check de version du serviceWorker
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    private router: Router,
    private attachmentService: AttachmentService, // pour init et alimentation de l'httpClient
    private swUpdateService: SwUpdateService
  ) {
    
    let mod: Model = Model.getInstance();
    
    // construction des routes depuis NavigationEngine
    const dynaRoutes: IWizRoute[] = NavigationEngine.buildRoute(RouteEngine.getRouteDefinition(), '');
    // mise à jour des routes (construction des fullPaths)
    this.router.resetConfig(dynaRoutes);
    // on force l'injection du modèle sur le routeur
    this.router['model'] = mod;
    // mémorisation des routes sur le modèle, pour utilisation par le tabEngine
    mod.routes = RouteEngine.getRouteDefinition(); 
    // mémorisation de la vue "vision" comme ajout systématique dans les tabs
    // mod.favoriteRoute = RouteEngine.VISION_VIEW;
    // alimentation du router sur navigation
    WizNavigationManager.router = this.router; 
  }
}
